import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { Popover } from '@material-ui/core';
import CmtSearch from '../../../../@coremat/CmtSearch';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { setUserSearchParams } from 'redux/actions/Users';

const SearchPopover = ({ iconClassName, popoverClassName, cancleIconClassName }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpenSearchBar = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseSearchBar = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const { userSearchParams } = useSelector(({ users }) => users);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const handleSearch = function(e) {
    if (pathname === '/users' || pathname === '/users/') {
      dispatch(setUserSearchParams(e.target.value));
    }
  };

  const handleClearSearchInput = function() {
    dispatch(setUserSearchParams(''));
  };

  return (
    <React.Fragment>
      <IconButton className={iconClassName} onClick={handleOpenSearchBar}>
        {userSearchParams ? <CloseIcon className={cancleIconClassName} onClick={handleClearSearchInput} /> : <SearchIcon />}
      </IconButton>
      <Popover
        className={popoverClassName}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseSearchBar}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <CmtSearch value={userSearchParams} onChange={handleSearch} />
      </Popover>
    </React.Fragment>
  );
};

export default SearchPopover;
